export const CritMessagesActionTypes = {
    UPDATE_CRIT_MESSAGES : ' UPDATE_CRIT_MESSAGES',
    UPDATE_ITEM_CRIT_MESSAGES : 'UPDATE_ITEM_CRIT_MESSAGES',
    UPDATE_USER_CRIT_MESSAGES : 'UPDATE_USER_CRITMESSAGES',
    ADD_TO_CRIT_MESSAGES : 'ADD_TO_CRIT_MESSAGES ',
}